import $ from 'jquery';
import View from 'root/view/base';
import Cache from 'root/cache';

export default View.extend({
    className: 'widget-demo',

    start: function() {
        var onMessage = (e) => {
            if (e.originalEvent.data.source !== 'demo') {
                return;
            }


            this.$el.find('.demo-window .preparing').hide();
            $(window).off('message.demo', onMessage);
        };

        $(window).on('message.demo', onMessage);

        // reload demo iframe
        this.$el.find('.demo-window .preparing').show();
        this.$el.find('.demo-window iframe').attr('src', '/' + Cache.getDefaultProject().get('project_key') + '/demo');
    },

    render: function() {
        var content =
        '<div class="demo-window">' +
            '<div class="preparing">' +
                '<span class="text-icon margin-right-8"><i class="fa-solid fa-spinner-third fa-spin"></i></span>Preparing the demo site...' +
            '</div>' +
            '<div class="demo-address-bar">' +
                '<div class="demo-address-bar-url">' + window.location.origin + '/' + Cache.getDefaultProject().get('project_key') + '/demo</div>' +
                '<button type="button" class="demo-address-bar-refresh tertiary tiny"><i class="fa-solid fa-rotate-right margin-right-4"></i>Refresh</button>' +
            '</div>' +
            '<iframe></iframe>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});
